export default {
    mounted(el: HTMLElement, binding: any) {
        let pressTimer: ReturnType<typeof setTimeout> | null = null

        const start = (e: Event) => {
            if (e.type === 'click' && (e as MouseEvent).button !== 0) return // seulement clic gauche
            if (pressTimer === null) {
                pressTimer = setTimeout(() => {
                    binding.value(e) // callback déclenché
                }, 600) // durée du long press
            }
        }

        const cancel = () => {
            if (pressTimer !== null) {
                clearTimeout(pressTimer)
                pressTimer = null
            }
        }

        el.addEventListener('mousedown', start)
        el.addEventListener('touchstart', start)
        el.addEventListener('mouseup', cancel)
        el.addEventListener('mouseleave', cancel)
        el.addEventListener('touchend', cancel)
        el.addEventListener('touchcancel', cancel)
    },
    unmounted(el: HTMLElement) {
        // bonne pratique : removeEventListener si besoin
    }
}
